(() => {
  const input = document.getElementById('swx-department-search');
  if (!input) return;
  const root = input.closest('.swx-directory');
  const status = root.querySelector('#swx-department-status');
  const groups = [...root.querySelectorAll('[data-swd-group]')];
  const ar = document.documentElement.lang.startsWith('ar');
  input.closest('.swx-directory-search').hidden = false;
  input.addEventListener('input', () => {
    const typed = input.value.trim().toLocaleLowerCase();
    const aliases = {'tvs':'tv','television':'tv','televisions':'tv','fridge':'refrigerator','fridges':'refrigerator','washing machine':'washer','washing machines':'washer','ac':'air-conditioner'};
    const query = aliases[typed] || typed;
    let matches = 0;
    groups.forEach(group => {
      const links = [...group.querySelectorAll('[data-swd-link]')];
      const parent = group.querySelector('header');
      const parentMatches = query && parent?.textContent.toLocaleLowerCase().includes(query);
      let visible = 0;
      links.forEach(link => {
        const match = !query || parentMatches || (link.textContent + ' ' + (link.dataset.swdSearch || '') + ' ' + link.getAttribute('href')).toLocaleLowerCase().includes(query);
        if (link.closest('li')) link.closest('li').hidden = !match;
        else if (!link.closest('header')) link.hidden = !match;
        if (match) { visible++; matches++; }
      });
      group.hidden = visible === 0;
    });
    status.textContent = !query ? '' : matches ? (ar ? `${matches} نتيجة` : `${matches} matching destinations`) : (ar ? 'لا توجد فئة مطابقة. استخدم البحث أعلى الصفحة للعثور على منتج.' : 'No matching category. Use the search at the top of the page to find a product.');
  });
})();
